<template>
  <div class="whole">
    <div class="text_data" flexContainer>
      <div class="block" flexContainer>
        <div class="title">新增用户（近30天）</div>
        <div class="number">{{user_obj.register}}</div>
        <div class="tip"></div>
      </div>
      <div class="block" flexContainer>
        <div class="title">活跃用户（今日）</div>
        <div class="number">{{user_obj.active}}</div>
        <div class="tip">
          昨日活跃用户{{user_obj.yesterdayActive}}
          <span>{{user_obj.activeRate}}</span>
          <i class="trangle-up"></i>
        </div>
      </div>
      <div class="block" flexContainer>
        <div class="title">累计用户</div>
        <div class="number">{{user_obj.amount}}</div>
        <div class="tip"></div>
      </div>
      <div class="block newblock" v-for="item in 2" :key="item"></div>
    </div>
    <div class="org_chart">
      <div class="title" flexContainer>
        <div
          class="main"
          v-for="item in user_array"
          :key="item"
          :class="{org_title:isUser == item.id}"
          @click="change_title(item.name,item.id)"
        >{{item.name}}</div>
        <div>
          <img src="@/assets/question.png" v-popover:popover1 />
        </div>
        <el-popover
          ref="popover1"
          placement="right-start"
          title
          width="400"
          trigger="hover"
          content
        >
          此页面展示的是当前担当平台（包括担当办公、云盘、短网址）所有用户数据
          <p>
            <b>新增用户：</b>第一次注册担当账号的用户（以账号为判断标准）
          </p>
          <p>
            <b>活跃用户：</b>符合不同产品活跃定义的用户（活跃用户不统计担当云资产、短网址）
          </p>
          <p>
            <b>累计用户：</b>截止到当前时间，启动过应用的所有独立用户（不同产品去重，以账号为判断标准）
          </p>
        </el-popover>
      </div>
      <div class="chart" flexContainer>
        <times></times>
        <chartone flex-1></chartone>
        <div class="way" flexContainer>
          <div class="line"></div>
          <div>{{isName}}</div>
        </div>
      </div>
    </div>
    <div class="org_chart new_chart">
      <div class="chart" flexContainer>
        <div class="title" flexContainer>
          <div class="name">用户活跃率</div>
          <!-- <div>
            <img class="new_icon" src="@/assets/question.png" v-popover:popover2 />
          </div> -->
          <el-popover placement="top-start" width="400" trigger="hover" style="color:#2479ED;">
            <p>
              <b>日活跃率：</b>日活跃用户占截止本日累计用户的比例
            </p>
            <p>
              <b>周活跃率：</b>周活跃用户占截止本周累计用户的比例
            </p>
            <p>
              <b>月活跃率：</b>月活跃用户占截止本月累计用户的比例
            </p>按天、周或月查看数据可直接选择查看所选日期范围内的周活跃率、月活跃率。周区间定义为周一至周日、月区间为自然月。按周（按月）显示时，界面上用每周的周一（每个月的第一日）来代表该周（该月）
            平台内任意一个软件内为活跃用户，则统计在活跃用户之中（注意去重）
            ——默认显示最近6周的的用户周活跃率
            <i
              class="el-icon-question"
              slot="reference"
            ></i>
          </el-popover>
        </div>
        <times></times>
        <chartwo flex-1></chartwo>
        <div class="way" flexContainer>
          <div class="line"></div>
          <div>{{isName_t}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { user_info } from "@/api/user";
export default {
  components: {
    times: () =>
      import(/* webpackChunkName: "components" */ "./components/time.vue"),
    chartone: () =>
      import(/* webpackChunkName: "components" */ "./components/chart_one.vue"),
    chartwo: () =>
      import(/* webpackChunkName: "components" */ "./components/chart_two.vue")
  },
  data() {
    return {
      isUser: 78101,
      isPer: 77111,
      isName: "活跃组织",
      isName_t: "组织活跃率",
      user_obj: {},
      text_array: [
        { name: "新增用户（近30天）", isOk: true },
        { name: "活跃用户（今日）", isOk: true },
        { name: "累计用户", num: 2 }
      ],
      user_array: [
        {
          name: "新增用户",
          id: 78101
        },
        {
          name: "活跃用户",
          id: 78102
        },
        {
          name: "累计用户",
          id: 78103
        }
      ],
      per_array: [
        {
          name: "组织活跃率",
          id: 77111
        },
        {
          name: "组织付费率",
          id: 77112
        },
        {
          name: "组织认证率",
          id: 77113
        }
      ]
    };
  },
  mounted() {
    this.info_fun();
  },
  methods: {
    //顶部数据
    info_fun() {
      user_info()
        .then(res => {
          this.user_obj = res.data;
        })
        .catch(error => {});
    },
    //切换user_array
    change_title(name, id) {
      this.isUser = id;
      this.isName = name;
    }
  }
};
</script>
<style lang="scss" scoped>
.whole {
  .text_data {
    @include text-part;
  }
  .org_title {
    @include click-class;
  }
  .org_chart {
    @include chart-class;
  }
  .new_chart {
    height: 296px;
    .chart {
      .title {
        margin-bottom: 15px;
        line-height: 16px;
        .name {
          @include s-c-w(16, $menu-text, 500);
          margin-right: 7px;
        }
      }
    }
  }
}
</style>